import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CrawfordSnackbarService, GridColumn, ITabComponent } from 'crawford-shell';
import { ClaimService } from '../../claim/claim.service';
import { UserService } from '../../user/user.service';
import { BaseSearchListComponent } from '../base-search-list.component';
import { SavedSearch } from '../model/saved-search.model';
import { SavedSearchService } from '../saved-search.service';




@Component({
  selector: 'app-current-user-searches',
  templateUrl: './current-user-searches.component.html',
  styleUrls: ['./current-user-searches.component.scss']
})
export class CurrentUserSearchesComponent extends BaseSearchListComponent implements OnInit, ITabComponent {
  public deleteHeaderTemplate = 'Deleting Saved Search {data.searchName} for {data.userName}';

  public currentUserSearches: SavedSearch[] = [];

  constructor(
    router: Router,
    savedSearchService: SavedSearchService,
    snackbarService: CrawfordSnackbarService,
    activatedRoute: ActivatedRoute,
    userService: UserService,
    claimService: ClaimService
  ) {
    super (
      router,
      savedSearchService,
      snackbarService,
      activatedRoute,
      userService,
      claimService
    );
  }

  protected buildGridColumns() {
    this.displayColumns = [
      new GridColumn('searchName', 'Search Description'),
      new GridColumn('lastUsedDate', 'Last Used', { type: 'date', format: this.df }),
      new GridColumn('retrieveButton', 'Retrieve', { template: this.templateRetrieveBtnRef }),
      new GridColumn('deleteButton', 'Delete', { template: this.templateDeleteBtnRef })
    ];

    this.columnsToAutoFit = [ 'retrieveButton', 'deleteButton' ];
  }

  public loadData(): void {
    if (!this.dataSource) {
      this.dataSource = this.savedSearchService.getCurrentUserSavedSearchDataManager(this.adaptor);
    } else {
      this.ccoGrid.search('');
    }
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/saved-search/current-user-searches/current-user-searches.component.ts